export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
} as const;
